import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Prism from 'prismjs';

import { Layout } from '../components';
import { GetPageQuery } from '../../graphql-types';

import { DefaultTemplateDiv } from './styles';

export default function DefaultTemplate({
  data: { asciidoc, sidebarYaml },
}: {
  data: GetPageQuery;
}) {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  const hasSidebar = sidebarYaml !== null;

  return (
    <Layout
      banner={asciidoc.document}
      seo={{ title: asciidoc.document.main }}
      sidebar={{
        location: asciidoc.fields.location,
        showIndex: sidebarYaml && sidebarYaml.showIndex,
      }}
      hasToC={asciidoc.fields.toc}
      hasSidebar={hasSidebar}
    >
      <DefaultTemplateDiv
        hasToC={asciidoc.fields.toc}
        hasSidebar={hasSidebar}
        dangerouslySetInnerHTML={{ __html: asciidoc.html }}
      ></DefaultTemplateDiv>
    </Layout>
  );
}

export const pageQuery = graphql`
  query GetPage($id: String, $parent: String) {
    asciidoc(id: { eq: $id }) {
      id
      html
      document {
        main
        title
        subtitle
      }
      fields {
        toc
        location
      }
    }
    sidebarYaml(name: { eq: $parent }) {
      id
      showIndex
    }
  }
`;
